module.exports = __webpack_public_path__ + "static/media/mdwa.ba50e0c5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/mdwa.woff2?62057485
// module id = 44
// module chunks = 0